module.exports = ".select-children {\n  max-height: 300px;\n  overflow: auto;\n}\n\n.age-input {\n  width: 4rem;\n}\n\n.max-width {\n  width: 100%;\n}"